// 浏览器可播协议（RTMP 只能推流，浏览器不能直接播）
export const PROTOCOLS = {
  webrtc: { name: 'WebRTC', latency: '0.3-1s', color: '#722ed1' },
  flv: { name: 'FLV', latency: '1-3s', color: '#52c41a' },
  hls: { name: 'HLS', latency: '3-10s', color: '#1890ff' }
};

/** 智能重试协议顺序：优先 WebRTC，失败再 FLV / HLS */
export const PROTOCOL_RETRY_ORDER = ['webrtc', 'flv', 'hls'];
